import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CadouAbout() {
  return <section className="py-20 lg:py-32 bg-white relative overflow-hidden" data-id="element-246">
      <div className="max-w-7xl mx-auto px-6" data-id="element-247">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-248">
          <SectionHeading title="Cine te va ghida în această sesiune" centered={true} data-id="element-249" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-251">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-252" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-253" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-254" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-255">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-256" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-257">
            <div className="hidden lg:block" data-id="element-258">
              <SectionHeading title="Cine te va ghida în această sesiune" centered={false} data-id="element-259" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-260">
              <p data-id="element-261">
                Sunt <strong data-id="element-262">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-263">
                Lucrez cu oameni care simt că viața lor poate fi mai bună, dar
                nu știu de unde să înceapă. Îi ghidez să identifice credințele
                din subconștient care îi blochează și să creeze mai multă
                abundență, liniște și armonie în viața lor.
              </p>

              <div className="p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-264">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-265">
                  "Ofer această sesiune gratuită pentru că știu că primul pas e
                  cel mai greu. Și vreau să îți fac acest prim pas cât mai
                  ușor."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-266" />
          </motion.div>
        </div>
      </div>
    </section>;
}